import { InferOutput, nullable, number, object, string } from "valibot"

export const citySchema = object({
  id: nullable(number()),
  cityNum: nullable(number()),
  cityName: nullable(string()),
  cityNameEn: nullable(string()),
  indexReference: nullable(number()),
})
export type CitySchema = InferOutput<typeof citySchema>

export const streetSchema = object({
  id: nullable(number()),
  cityNum: nullable(number()),
  cityName: nullable(string()),
  cityNameEn: nullable(string()),
  streetName: nullable(string()),
  streetNameEn: nullable(string()),
  indexReference: nullable(number()),
})
export type StreetSchema = InferOutput<typeof streetSchema>
